<template>
    <div>
      <b-card>
      <b-row>
        <b-col
          cols="12"
          md="3"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
        <flat-pickr
          v-model="rangeDate"
          class="form-control mb-1 mr-1"
          :config="{ mode: 'single',dateFormat: 'Y-m'}"
        />
        </b-col>
        <b-col
          cols="12"
          md="1"
          class="d-flex align-items-center justify-content-start mb-1"
        >
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="d-flex align-items-center justify-content-end mb-1"
        >
        <v-select :reduce="center => center.id" :options="centerOptions" v-model="form.center_id"></v-select>
        </b-col>
        <b-col
          cols="12"
          md="5"
        >
          <div class="d-flex align-items-center justify-content-end mb-1">
           
            <b-form-input
                v-model="form.goal_amount"
                ref="search"
                class="d-inline-block mx-1"
                placeholder="Enter Goal Amount"
            />
            <b-button
              variant="primary"
              @click="add_target()"
              v-if="$can('read', 'staff')"
            >
              <span class="text-nowrap"> {{$t('新增目標')}} </span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <!-- table -->
      <b-table
        ref="selectableTable"
        selectable
        :select-mode="selectMode"
        :items="items"
        :fields="fields"
        responsive
        striped
        @row-selected="onRowSelected"
      >
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
  
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item :to="{ name: 'apps-Member-view', params: { id: data.item.id } }">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Details</span>
            </b-dropdown-item>
  
            <b-dropdown-item :to="{ name: 'apps-Member-edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
  
            <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
        <template #cell(status_number)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell(delete)="data">
          <b-button
            variant="danger"
            @click="delete_record(data.item.id)"
             size="sm"
          >
            <span class="text-nowrap"> 刪除 </span>
          </b-button>
        </template>
      </b-table>
      <b-row>
        
        <b-col>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            align="right"
            size="md"
            class="my-0"
            @change="handleChangePage"
          />
        </b-col>
      </b-row>
    </b-card>
    </div>
  </template>
  
  <script>
  import BCardCode from '@core/components/b-card-code/BCardCode.vue'
  import vSelect from 'vue-select'
  import flatPickr from 'vue-flatpickr-component'
  import moment from 'moment'
  import Ripple from 'vue-ripple-directive'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import {
    BTable, BAvatar, BCardBody, BCard, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,
  } from 'bootstrap-vue'

  export default {
    components: {
      BTable,
      BAvatar,
      BBadge,
      BRow,
      flatPickr,
      moment,
      BCard,
      BCol,
      BFormGroup,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BInputGroupPrepend,
      BButton,
      BPagination,
      BCardCode,
      BTable,
      BButton,
      BFormGroup,
      BAvatar,
      BCardBody,
      BBadge,
      vSelect,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
        test_string : null,
        form : {
            goal_amount: null,
            center_id:null,
            goal_date: moment().format("YYYY-MM"),
        },
        rangeDate: moment().format("YYYY-MM"),
        genderOptions: [
          { label: 'Male', value: 'M' },
          { label: 'Female', value: 'F' },
        ],
        planOptions: [
          { label: 'Basic', value: 'basic' },
          { label: 'Company', value: 'company' },
          { label: 'Enterprise', value: 'enterprise' },
          { label: 'Team', value: 'team' },
        ],
        statusOptions: [
          { label: 'Active', value: 'active' },
          { label: 'Disabled', value: 'disabled' },
        ],
        status: [{
          1: 'ACTIVE', 2: 'DISABLED', 3: 'DELETED'
        },
        {
          1: 'light-success', 2: 'danger', 3: 'info'
        }],
        centerOptions: [],
        isAddNewMemberSidebarActive: false,
        searchString: null,
        rollback : false,
        existData:null,
        perPage: 10,
        action:'edit',
        startRow: 1,
        endRow: 10,
        pageOptions: [10, 15, 20],
        totalRows: 1,
        currentPage: 1,
        fields: [
          { key: 'code', label: "分校" , sortable: true},
          { key: 'goal_date', label: "月份" , sortable: true},
          { key: 'amount', label: "目標" , sortable: true},
          { key: 'delete', label: "刪除" , sortable: true}
        ],
        /* eslint-disable global-require */
        items: [],
        /* eslint-disable global-require */
        status: [{
          1: 'Active', 2: 'Disabled', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
        },
        {
          1: 'light-success', 2: 'light-danger', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
        }],
        selectMode: 'single',
        selected: [],
      }
    },
    mounted() {

    },
    watch: {
        rangeDate : {
        handler(newValue, oldValue) {
          this.get_data()
          this.form.goal_date = newValue
        },
      },
      currentPage: {
        handler(newValue, oldValue) {
          this.$store.commit('member_search/UPDATE_PAGE', newValue)
          this.get_data()
        },
      },
      searchString: {
        handler(newValue, oldValue) {
          // console.log("search")
          this.searchString = newValue.toUpperCase()
          this.$store.commit('member_search/UPDATE_KEYWORD', this.searchString)
          this.handleSearch()
        },
      },
      perPage: {
        handler(newValue, oldValue) {
          if (newValue < 9) {
            this.perPage = 10
          }
          // console.log("search")
          this.handleSearch()
        },
      },
    },
    created() {
        this.get_center_data()
        this.get_data()
 

    },
    methods: {
      one() {
        this.isAddNewMemberSidebarActive = false
        this.get_data()
      },
      add_target() {
        this.$http.post(process.env.VUE_APP_API_BASE+`/goal/add/`,this.form)
          .then(res => {
            if (res.data.result === false) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                    title: 'Error',
                    icon: 'XIcon',
                    variant: 'danger',
                    text: res.data.message,
                    },
          }) 
            } else {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                        title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                    text: '新增成功'
                    },
                })
            this.get_data()
            this.form.goal_amount = null
            }
          })
      },
      get_data() {
        this.$http.get(process.env.VUE_APP_API_BASE+`/goals/?target=${this.rangeDate}`)
          .then(res => {     
            this.items = res.data.goals
            this.totalRows = res.data.total
            this.startRow = res.data.startRow
            this.endRow = res.data.endRow
            //  console.log( res.data.members.length)
          })
      },
      delete_record(id) {
        this.$http.post(process.env.VUE_APP_API_BASE+`/goal/`+ id +`/delete/`,{})
          .then(res => {
            this.get_data()
          })
      },
      get_center_data() {
        this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
          .then(res => {
            this.centerOptions = res.data.centers
          })
      },
      handleChangePage() {
  
      //  this.get_data()
      },
      onRowSelected(items) {
        this.existData = items[0]
        this.action = 'edit'
        this.isAddNewMemberSidebarActive = true

      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      selectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.selectRow(2)
      },
      unselectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.unselectRow(2)
      },
  
      handleSearch() {
        // let _print = `The user searched for: ${searching}\n`
        // this.$refs.pre.appendChild(document.createTextNode(_print))
      // this.searchString = searching
      // this.currentx = 1
      // this.get_data()
        this.searchTimeOut()
      },
      searchTimeOut() {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          // your code
          this.currentPage = 1
          this.get_data()
        }, 500)
      },
    },
  }
  </script>
  
  <style lang="scss">
  .v-select {
    width:100%;
  }
  .b-table-selectable{
    .feather{
      font-size: 1.3rem;
    }
  }
  
  </style>
  